import styled from 'styled-components';

const Titulo = styled.h1 `
    
    position: relative;
    text-align: left;
    color: var(--title-text-color);
    font-family: Lato,sans-serif;
    font-weight: 700;
     
     &:after {
    content: "";
    position: absolute;
    bottom: -1.5px;
    left: 0;
    width: 56px;
    max-width: 80%;
    height: 3px;
    border-radius: 1.5px;
    background: linear-gradient(309.58deg,#CA361C,#F1C218)
  }
`   
;

export default Titulo;